<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <!-- {{sendingSchedule}} -->
        <!-- activeIndex: {{activeIndex}}-->
        <!-- {{formParam}}
        <hr />
        {{formParamScrapeSt}}-->
        <div class="col-md-8">
          <div class="col-md-12 profile-info-left">
            <table class="table">
              <tbody>
                <tr>
                  <td class="text-muted text-left" style="width:30%">Title</td>
                  <th class="text-left">{{formParamScrapeSt.title}}</th>
                </tr>
                <tr>
                  <td class="text-muted text-left" style="width:30%">Brand/Merek</td>
                  <th class="text-left" ref="brand">
                    <Skeleton :count="1" />
                  </th>
                </tr>
                <tr>
                  <td class="text-muted text-left">Product</td>
                  <th class="text-left" ref="product">
                    <Skeleton :count="1" />
                  </th>
                </tr>
                <tr>
                  <td class="text-muted text-left">Keywords</td>
                  <th class="text-left" ref="keywords">
                    <Skeleton :count="1" />
                  </th>
                </tr>
                <tr>
                  <td class="text-muted text-left">Range Harga</td>
                  <th
                    class="text-left"
                  >{{formatPrice(formParamScrapeSt.min_price)}} - {{formatPrice(formParamScrapeSt.max_price)}}</th>
                </tr>
                <tr>
                  <td class="text-muted text-left">Urutkan</td>
                  <th
                    class="text-left"
                  >{{marketplaceLabelFilter(formParamScrapeSt.sort_by,formParamScrapeSt.order_by)}}</th>
                </tr>
                <tr>
                  <td class="text-muted text-left">Marketplace</td>
                  <th class="text-left">
                    <span
                      v-for="marketplace in formParamScrapeSt.mp_id"
                      :key="marketplace"
                      v-html="marketplaceIcon(marketplace.id)"
                    ></span>
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-12">
              <label class="col-form-label">
                Scrape Options
                <span class="text text-danger">*</span>
              </label>
              <div class="radio">
                <label
                  :style="'margin-left:10px;'"
                  v-for="(row,index) in listSendingOptions"
                  :key="index"
                >
                  <input
                    :id="row.id"
                    type="radio"
                    :value="row.id"
                    v-model="formParam.sending_options"
                    @change="formValidate"
                  />
                  {{row.label}}
                </label>
              </div>
            </div>
            <div class="col-md-12" v-if="formParam.sending_options=='2'">
              <div class="form-group">
                <label>Time to scrape:</label>

                <div class="cal-icon">
                  <datetime
                    :min-datetime="currentDateTimeUTC()"
                    :zone="'local'"
                    :use12-hour="true"
                    input-class="form-control"
                    value-zone="UTC"
                    type="datetime"
                    v-model="sendingSchedule"
                  ></datetime>

                  <!-- <input type="text" class="form-control floating datetimepicker" /> -->
                </div>
                <!-- <span
                    v-if="broadcastParam.sending_schedule!=''"
                >UTC: {{broadcastParam.sending_schedule}}</span>-->
              </div>
            </div>
          </div>
          <scheduler v-show="false" :activeIndex="activeIndex" />
          <div class="row" v-show="false">
            <div class="col-md-12">
              <div class="form-group">
                <label for="maxPaginationStatus">Hanya Page 1:</label>
                <div class="checkbox">
                  <input v-model="maxPaginationStatus" type="checkbox" id="maxPaginationStatus" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";

import {
  currentDateTimeUTC,
  marketplaceIcon,
  formatPrice,
  marketplaceLabelFilter
} from "@/utils/helper";
import Scheduler from "./scheduler.vue";

import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";
export default {
  components: {
    Skeleton,
    Scheduler,
    Datetime
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      maxPaginationStatus: false,
      sendingSchedule: "",
      formParam: {
        max_pagination_status: false,
        sending_options: 1,
        sending_schedule: ""
      },
      listSendingOptions: [
        { id: 1, label: "Now" },
        // { id: 2, label: "Schedule" }
        // { id: 3, label: "Send a test" }
      ],
      dataListMarketplace: [],
      formMPId: [],
      selectedMPId: [],
      isLoading: false
    };
  },
  watch: {
    formParamScrapeSt: {
      handler: async function(val, oldVal) {
        if (val != oldVal) {
          // console.log("oldValForm3", oldVal);
          // console.log("newValForm3", val);

          this.formParam.is_publish = 1;
          this.maxPaginationStatus = val.max_pagination_status;
          this.formParam.max_pagination_status = val.max_pagination_status;
          this.formParam.sending_options = val.sending_options;
          this.formParam.sending_schedule = val.sending_schedule;
          this.sendingSchedule = val.sending_schedule;
        }
      },
      deep: true
    },
    maxPaginationStatus: {
      handler: async function(val, oldVal) {
        if (val != oldVal) {
          this.formParam.max_pagination_status = val;
          this.formValidate();
        }
      },
      deep: true
    },
    sendingSchedule: {
      handler: async function(val, oldVal) {
        if (val != oldVal) {
          this.formValidate();
        }
      },
      deep: true
    },
    activeIndex: {
      handler: async function(val, oldVal) {
        if (val == 2) {
          // that.getMarketplaceList();
          await this.getLabel();
          this.formValidate();
        }
      },
      deep: true
    }
  },
  computed: {
    formParamScrapeSt() {
      return this.$store.state.monitoring.formParamScrapeSt;
    }
  },
  filters: {
    capitalising: function(data) {
      var capitalized = [];
      data.split(" ").forEach(word => {
        capitalized.push(
          word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );
      });
      return capitalized.join(" ");
    }
  },
  methods: {
    formValidate() {
      // let newParam = {
      //   mp_product_master_id: "",
      //   keywords_id: [],
      //   min_price: 0,
      //   max_price: 0,
      //   sort_by: "price",
      //   order_by: "asc",
      //   mp_id: [],
      //   sending_options: 1,
      //   is_publish: 1,
      //   // is_recurring: 0,
      //   // recurring_form: {
      //   //   recurrence: "",
      //   //   recurrence_time: "00:01",
      //   //   recurrence_every: "",
      //   //   recurrence_annually_month: "",
      //   //   recurrence_end: "never",
      //   //   recurrence_end_date: ""
      //   // }
      // };

      let newParam = this.formParamScrapeSt;
      // newParam.mp_product_master_id = form1.mp_product_master_id;
      // newParam.keywords_id = form1.keywords_id;
      // newParam.min_price = parseInt(form1.min_price);
      // newParam.max_price = parseInt(form1.max_price);
      // newParam.sort_by = form1.sort_by;
      // newParam.order_by = form1.order_by;
      // newParam.mp_id = form1.mp_id;
      // newParam.is_recurring = form1.is_recurring;
      // newParam.recurring_form = form1.recurring_form;
      newParam.is_publish = 1;
      newParam.max_pagination_status = this.maxPaginationStatus;
      newParam.sending_options = this.formParam.sending_options;
      newParam.sending_schedule = this.sendingSchedule;

      this.$store.dispatch("monitoring/actFormParamScrapeSt", newParam);
      console.log("newParamForm3", newParam);
    },
    marketplaceLabelFilter(sortBy, orderBy) {
      return marketplaceLabelFilter(sortBy, orderBy);
    },
    marketplaceIcon(value) {
      return marketplaceIcon(value);
    },
    formatPrice(number) {
      return formatPrice(number);
    },
    async getLabel() {
      let brandId = "0";
      await this.$store
        .dispatch(
          "brandProduct/detail",
          this.formParamScrapeSt.mp_product_master_id
        ) // sesuai kan dengan method di API
        .then(responseDet => {
          var resData = responseDet.data;
          brandId = resData.brand_id;
          this.$refs.product.innerHTML = resData.name;
        });
      this.$store
        .dispatch("brand/detail", brandId) // sesuai kan dengan method di API
        .then(responseDet => {
          var resData = responseDet.data;
          this.$refs.brand.innerHTML = resData.name;
        });

      let keywordsLabel = await "";
      await this.formParamScrapeSt.keywords_id.forEach(
        async (keywordId, idx) => {
          await this.$store
            // .dispatch("monitoring/detailKeywords", keywordId) // sesuai kan dengan method di API
            .dispatch("monitoring/detailKeywords", keywordId.id) // sesuai kan dengan method di API
            .then(async responseDet => {
              var resData = responseDet.data;
              if (idx == 0) {
                keywordsLabel = await resData.name;
                // console.log("keywordsLabel1", keywordsLabel);
                this.$refs.keywords.innerHTML = await keywordsLabel;
              } else {
                keywordsLabel += (await ", ") + resData.name;
                this.$refs.keywords.innerHTML = await keywordsLabel;
                // console.log("keywordsLabel2", keywordsLabel);
              }
            });
        }
      );
      // this.$refs.keywords.innerHTML = await keywordsLabel;
      // await console.log("keywordsLabel3", keywordsLabel);
    },
    currentDateTimeUTC() {
      return currentDateTimeUTC();
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>


// WEBPACK FOOTER //
// src/views/monitoring/scrape/components/form3.vue